import C502_FacultyDetail from "@components/C50.2_FacultyDetail/C50.2_FacultyDetail";
import C54_ProfilePhotoLinkBox from "@components/C54_ProfilePhotoLinkBox/C54_ProfilePhotoLinkBox";
import Grid from "@components/Grid/Grid";
import RenderComponents from "@utilities/renderComponents";
import Head from "next/head";
import {
  FacultyDetailContextProps,
  FacultyDetailProvider,
} from "../../../context/facultyDetails";

import { TypeFacultyProfileDetailFields } from "@customTypes/contentful";

import StructuredData from "@components/StructuredData/StructuredData";
import { getContentfullImagePath } from "@utilities/getContentfullImagePath";

export interface FacultyProfileDetailProps extends FacultyDetailContextProps {
  bodyContent?: TypeFacultyProfileDetailFields["bodyContent"];
  detailContent?: TypeFacultyProfileDetailFields["detailContent"];
  profileBoxContent?: TypeFacultyProfileDetailFields["profileBoxContent"];
}

export const FacultyProfileDetail = (props: {
  content: FacultyProfileDetailProps;
}) => {
  const { content } = props;

  const { bodyContent, detailContent, profileBoxContent, ...details } = content;
  const {
    profilePositionTitle,
    profilePhoto,
    facultyProfileData,
    profileResearchActivityList,
  } = details;

  const profileSurname = facultyProfileData?.fields?.profileSurname;
  const profileFirstName = facultyProfileData?.fields?.profileFirstname;
  const profileSubjectArea = facultyProfileData?.fields?.profileSubjectArea;
  const title =
    content?.facultyProfileData?.fields?.profilePositionTitle ||
    profilePositionTitle;
  const profileImage = profilePhoto?.fields?.file?.url;
  const url = `${process.env.NEXT_PUBLIC_URL}/${content?.slug}`;

  const schemaData = {
    "@type": "Person",
    name: `${profileFirstName} ${profileSurname}`,
    jobTitle: title,
    worksFor: {
      "@type": "Organization",
      name: "London Business School",
    },
    url: url,
    image: `https:${profileImage}`,
  };

  return (
    <FacultyDetailProvider details={details}>
      <Head>
        <meta name="profilesubjectarea" content={profileSubjectArea || ""} />
        <meta
          name="profilephotosmallurl"
          content={
            profilePhoto?.fields?.file?.url
              ? getContentfullImagePath(profilePhoto?.fields?.file?.url)
              : ""
          }
        />
        <meta
          name="profilephotosmallalt"
          content={
            profilePhoto?.fields?.description ||
            profilePhoto?.fields?.title ||
            ""
          }
        />
        <meta name="profilepositiontitle" content={title || ""} />
        <meta name="profilesurname" content={profileSurname || ""} />
        <meta
          name="profileresearchactivitylist"
          content={
            profileResearchActivityList
              ? profileResearchActivityList
                  ?.map((activity) => {
                    return activity;
                  })
                  .join(";")
              : ""
          }
        />
      </Head>
      <div className="outer-wrap">
        <div className="wrapper">
          <Grid row justify="space-between">
            <Grid column sm={12} md={8}>
              <C502_FacultyDetail />
              {RenderComponents(detailContent)}
            </Grid>
            <Grid column sm={12} md={4} customClass="tp4">
              <C54_ProfilePhotoLinkBox
                // @ts-expect-error type mistmatch
                content={{ ...details, ...details.facultyProfileData }}
              />
              {RenderComponents(profileBoxContent)}
            </Grid>
          </Grid>
        </div>
      </div>
      {RenderComponents(bodyContent)}
      <StructuredData id="facultyProfileSiteMeta" schemaData={schemaData} />
    </FacultyDetailProvider>
  );
};

export default FacultyProfileDetail;
